export const resumeData = {
  name: "Tarang Donga",
  title: "Software Engineer",
  contact: {
    email: "tarangkdonga@gmail.com",
    linkedin: "https://www.linkedin.com/in/tarang-donga",
    phone: "+91 7479777333",
    github: "https://github.com/tarangdonga",
    website: "www.tarangdonga.com",
    resume: "https://drive.google.com/file/d/1rekoGU1y3rtDMw9CjUtwkySgcAVhcx7F/view?usp=sharing"
  },
  summary: "Software Engineer with a Master's from Columbia University specializing in Software Systems and full-stack architecture, focusing on delivering high-impact projects from concept to launch.",
  // summary: "Experienced in leading full-stack architecture, developing scalable RESTful APIs, and delivering high-impact projects from concept to launch. Proven ability to leverage modern technologies like React, Laravel, Python, and the Gemini API.",
  skills: {
    languagesFrameworks: [
      "Python", "C++", "Java", "JavaScript", "TypeScript", "PHP", "C#", "Django",
      "Flask", "React", "React Native", "Laravel", "REST API", "SQL",
      "HTML", "CSS", "MATLAB", "R", "Visual Basic"
    ],
    toolsPlatforms: [
      "Git", "Linux", "AWS", "GCP", "Android Studio", "VS Code", "Microsoft Office Suite"
    ],
  },
  experience: [
    {
      title: "Associate System Engineer - Application Developer",
      company: "IBM",
      location: "Bangalore, India",
      duration: "May 2026 - Present",
      description: [
        "Completing an intensive Cloud Full-Stack Application Development training program, mastering enterprise-level development methodologies."
      ],
      tags: ["Java", "Spring Boot", "Angular", "React", "MongoDB", "Docker", "Kubernetes", "CI/CD"],
    },
    {
      title: "Software Engineer Intern",
      company: "Paramatrix Technologies Ltd.",
      location: "Navi Mumbai, India",
      duration: "Jan 2026 - May 2026",
      description: [
        "Spearheaded the development of a secure, Django-based code generation tool with REST APIs and JWT authentication to automatically parse database schema diagrams into functional models and CRUD endpoints, accelerating initial project setup time by nearly 60%."
      ],
      tags: ["Django", "SQL", "Jinja2", "REST API", "JWT", "Celery", "Redis", "Docker"],
    },
    {
      title: "Founding Engineer",
      company: "Culinary Companion",
      location: "New York, NY",
      duration: "Jun 2025 - May 2026",
      description: [
        "Spearheaded the architecture and development of a full-stack restaurant discovery web app, focused on dietary and allergen-based filtering.",
        "Designed and implemented scalable RESTful APIs with Laravel and PostgreSQL, supporting dynamic restaurant search, filtering, and sorting.",
        "Collaborated directly with the founder on product roadmap, branding, and user experience design, shaping the MVP from concept to launch."
      ],
      tags: ["Laravel", "SQL", "Full-Stack", "REST API", "PostgreSQL"],
      links: [
        { label: "Live Website", url: "https://www.culinarycompanion.nyc", type: "website" }
      ],
      images: [

      ]
    },
    {
      title: "Software Developer",
      company: "AnTim Technologies",
      location: "Remote",
      duration: "Feb 2025 - Aug 2025",
      description: [
        "Developed scalable RESTful APIs to support dynamic web applications used by enterprise clients.",
        "Designed and optimized SQL queries to retrieve, filter, and aggregate data across multiple relational databases.",
        "Led a project for the development of a robust license plate recognition system using Python and YOLO11.",
        "Implemented automated test coverage thresholds to enforce code quality standards."
      ],
      tags: ["Python", "SQL", "YOLOv8", "Automation"]
    },
    {
      title: "Software Engineer",
      company: "Feld Entertainment",
      location: "Gainesville, FL",
      duration: "Aug 2022 - Apr 2023",
      description: [
        "Built a real-world project sponsored by Feld Entertainment with a team of multi-disciplinary engineers.",
        "Developed a fully automated system that can record and self-edit videos capturing the most thrilling moments for riders on Monster Jam ride trucks.",
        "Excelled at multiple responsibilities such as software design, automation, hardware integration, and collaboration with professionals."
      ],
      tags: ["C++", "Python", "Flask", "MoviePy", "ffmpeg", "Automation", "Hardware Integration"],
      links: [
        { label: "About the Project", url: "https://www.ippd.ufl.edu/blogs/ay2223team08/learn-about-our-project/", type: "external" },
        { label: "View Project Poster", url: "https://drive.google.com/file/d/1fzn2vYz5QE4xkQjRYchHn_Jt9fAqhkM_/view?usp=sharing", type: "doc" },
        { label: "Feld Entertainment Press Release", url: "https://www.feldentertainment.com/feld-entertainment-teams-with-university-of-florida-for-engineering-project", type: "article" },
        { label: "Develpment Stage Blogs", url: "https://www.ippd.ufl.edu/blogs/ay2223team08/blog-posts/", type: "blog" }
      ]
    }
  ],
  projects: [
    {
      name: "Cookmunity",
      duration: "Nov 2023 - Feb 2024",
      description: "Designed and built a social media app to share and search recipes using Flask and PostgreSQL. Leveraged Google's Gemini API to deliver real-time search results with a feedback loop to improve relevancy.",
      tags: ["Flask", "PostgreSQL", "Gemini API"],
      imagePlaceholder: "Cookmunity App"
    },
    {
      name: "EcoFlo App",
      duration: "Sep 2021 - Nov 2021",
      description: "Designed and developed an app using React Native to help with proper waste disposal, carbon emission tracking, and step tracking with a leaderboard.",
      tags: ["React Native", "Sustainability", "Mobile Dev"],
      imagePlaceholder: "EcoFlo App"
    }
  ],
  education: [
    {
      institution: "Columbia University",
      degree: "MS in Computer Science",
      details: "Specialization Track: Software Systems | GPA: 3.73/4.00",
      duration: "Dec 2024",
    },
    {
      institution: "University of Florida",
      degree: "BS in Computer Science (Engineering)",
      details: "Minor: Business Administration | GPA: 3.96/4.00 | Honors: Dean's List (6x), President's Honor Roll (5x)",
      duration: "May 2023",
    }
  ]
};